import type { AppManifest } from '@sparky/framework'
import { APP_ID_LOGGING_SERVICE, SLS_TYPES } from '../constants/GlobalConstants'
import { ARRAY, indexArray } from './Utils'

export const overWriteAppDefAtRuntime = (apps: AppManifest[], instances: any) => {
  if (!ARRAY.hasArray(instances)) {
    return apps
  }

  const instanceMap: Record<string, any> = indexArray(instances, 'app_id')
  return apps.map((app) => {
    const instance = instanceMap?.get(app.app_id)

    switch (app.app_id) {
      case APP_ID_LOGGING_SERVICE:
        // set default
        app.device_association = {
          ...app?.device_association,
          view_association: true,
          remove_association: false,
          enabled: false
        }

        // override
        if (instance?.extra?.type === SLS_TYPES.SLS) {
          app.device_association = {
            ...app?.device_association,
            view_association: true,
            remove_association: true,
            enabled: true
          }
        }

        break
      default:
        break
    }
    return app
  })
}
